import { createContext, useContext, useEffect, type ReactNode } from 'react'
import { getTenantConfig, type TenantConfig } from './tenant-config'

const tenantConfig = getTenantConfig()

const TenantContext = createContext<TenantConfig>(tenantConfig)

/**
 * Setzt Branding-Werte (Logo, Farben, App-Name) aus der Mandanten-Config
 * als CSS Custom Properties und stellt die Config per Context bereit.
 */
export function TenantProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const { branding } = tenantConfig

    // CSS Custom Property für Primärfarbe setzen
    document.documentElement.style.setProperty('--brand-primary', branding.primary_color)

    // Seitentitel setzen
    document.title = branding.name

    // Favicon setzen, falls konfiguriert
    if (branding.favicon_url) {
      const link =
        (document.querySelector("link[rel~='icon']") as HTMLLinkElement) ||
        document.createElement('link')
      link.rel = 'icon'
      link.href = branding.favicon_url
      document.head.appendChild(link)
    }
  }, [])

  return (
    <TenantContext.Provider value={tenantConfig}>
      {children}
    </TenantContext.Provider>
  )
}

/**
 * Hook um auf die aktive Mandanten-Config zuzugreifen.
 */
export function useTenant(): TenantConfig {
  return useContext(TenantContext)
}
